import styled from 'styled-components';

const  ProgressButton  =  styled.button`
  background:  linear-gradient(to right, #708238 ${props => props.scroll}%, #FFFFFF ${props => props.scroll}%);
`;

export  default  ProgressButton;